import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Flame, ShieldCheck } from 'lucide-react';
import { siteInfo, navLinks } from '../mock';

export default function Footer() {
  return (
    <footer className="border-t border-[#2e2822] bg-[#100d0a]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <Flame className="h-6 w-6 text-orange-500" />
              <span className="font-heading text-xl font-extrabold"><span className="text-white">24BET</span><span className="orange-text-gradient">BOX</span></span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-neutral-400">
              Elite football predictions crafted by a team of verified professional tipsters. We publish every result openly — bet smart, bet with confidence.
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-neutral-400">
              <Mail className="h-4 w-4 text-orange-500" />
              <a href={`mailto:${siteInfo.email}`} className="hover:text-orange-400">{siteInfo.email}</a>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-lg font-bold text-white">Quick Links</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-neutral-400 hover:text-orange-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg font-bold text-white">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/terms" className="text-neutral-400 hover:text-orange-400">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="text-neutral-400 hover:text-orange-400">Privacy Policy</Link></li>
              <li><Link to="/about" className="text-neutral-400 hover:text-orange-400">About Us</Link></li>
            </ul>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border border-[#2e2822] bg-white/5 px-3 py-2 text-xs text-neutral-400">
              <ShieldCheck className="h-4 w-4 text-orange-500" /> 18+ Bet Responsibly
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-[#2e2822] pt-6 text-center text-xs text-neutral-500">
          <p>© 2025 {siteInfo.domain}. All rights reserved. Predictions are provided for informational purposes only and are not guarantees. Gambling involves risk — please play responsibly.</p>
        </div>
      </div>
    </footer>
  );
}
